import OutboundSsoLink from './OutboundSsoLink'
import OutboundSsoButton from './OutboundSsoButton'

const outboundSsoModule = {
  SsoLink: OutboundSsoLink,
  SsoButton: OutboundSsoButton
}

export default outboundSsoModule
